import AlertBanner from "@/pages/home/components/AlertBanner";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import AboutTabs from "./components/AboutTabs";

export default function About() {
  return (
    <div className="min-h-screen flex flex-col">
      <AlertBanner />
      <Header />
      <main className="flex-1">
        <AboutTabs />
      </main>
      <Footer />
    </div>
  );
}